var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiriusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 80,
    viewBox: "0 0 300 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_486_507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9556 43.4456H36.7617L42.7535 37.7016C43.1859 37.2871 42.8771 36.5691 42.2671 36.5691H32.1288L24.9633 43.4382L24.9556 43.4456Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13842 39.9963H0C0 28.6934 9.59005 19.5 21.3807 19.5C27.0946 19.5 32.461 21.6318 36.4993 25.5031L30.7468 31.0176C28.2451 28.6193 24.9171 27.2944 21.3807 27.2944C14.0762 27.2944 8.1307 32.994 8.1307 39.9963H8.13842Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9482 43.4531C23.9907 44.3784 22.709 44.8817 21.35 44.8817C19.991 44.8817 18.7093 44.371 17.7518 43.4531C15.7674 41.5508 15.7674 38.4493 17.7518 36.547L11.9993 31.0325C6.84138 35.977 6.84138 44.0231 11.9993 48.9677C14.5011 51.3659 17.8213 52.6835 21.35 52.6835C24.8787 52.6835 28.2067 51.3659 30.7084 48.9677L24.9559 43.4531H24.9482Z",
    fill: "#5DC5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3808 60.5C15.6669 60.5 10.3005 58.3682 6.26221 54.497L12.0147 48.9824C14.5164 51.3807 17.8444 52.7057 21.3808 52.7057C24.9173 52.7057 28.2452 51.3881 30.747 48.9824L36.4994 54.497C32.4611 58.3682 27.087 60.5 21.3808 60.5Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0071 48.4051C64.6904 48.4051 66.2578 48.1016 67.6708 47.4873V42.8832C66.8524 43.579 65.3312 43.9713 63.6866 43.9713C61.5941 43.9713 59.5479 42.9646 59.5479 40.5663C59.5479 37.8424 61.6172 36.7913 63.8024 36.7913C65.2077 36.7913 66.6671 37.2502 67.555 37.835V33.3419C66.142 32.735 64.505 32.4241 62.8681 32.4241C58.4978 32.4241 54.1351 34.7557 54.1583 40.5589C54.1583 46.1179 58.5055 48.3829 63.0071 48.3829V48.4051Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0982 39.8336V48.0573H88.3565V32.7869H83.9166L77.3766 41.0106V32.7869H72.126V48.0573H76.5581L83.0982 39.8336Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.698 39.8336V48.0573H126.956V32.7869H122.516L115.976 41.0106V32.7869H110.718V48.0573H115.158L121.698 39.8336Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.336 48.4051C160.02 48.4051 161.587 48.1016 163 47.4873V42.8832C162.182 43.579 160.66 43.9713 159.023 43.9713C156.931 43.9713 154.885 42.9646 154.885 40.5663C154.885 37.8424 156.954 36.7913 159.139 36.7913C160.552 36.7913 162.004 37.2502 162.892 37.835V33.3419C161.479 32.735 159.842 32.4241 158.205 32.4241C153.835 32.4241 149.472 34.7557 149.495 40.5589C149.495 46.1179 153.842 48.3829 158.344 48.3829L158.336 48.4051Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.982 42.3947L135.357 48.0573H140.824L148.267 32.7869H142.422L139.102 39.9595L135.396 32.7869H129.612L134.909 42.3947H137.982Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1395 44.519H101.606C104.981 44.519 107.722 41.8913 107.722 38.6566C107.722 35.4219 104.981 32.7942 101.606 32.7942H92.9507V48.0572H98.1318V44.519H98.1395ZM101.058 36.9838C102.023 36.9838 102.803 37.7314 102.803 38.6566C102.803 39.5819 102.023 40.3295 101.058 40.3295H98.1395V36.9838H101.058Z",
    fill: "#283581"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_486_507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 41,
    fill: "white",
    transform: "translate(0 19.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiriusLogo);
export default __webpack_public_path__ + "static/media/sirius_logo.cea58a706d37036ea61e151781a8e404.svg";
export { ForwardRef as ReactComponent };